import { getMemberJWTTokenKey } from './getMemberJWTTokenKey.web';
import { removeAblyCookie } from './removeAblyCookie.web';

export const removeMemberToken = async () => {
  const memberJWTTokenKey = await getMemberJWTTokenKey();
  removeAblyCookie(memberJWTTokenKey);
};
